import { isBaseUrlProd } from '@shared';
import {
  AUTH0_DOMAIN,
  AUTH0_CLIENT_ID,
  AUTH0_AUDIENCE,
  DEV_AUTH0_DOMAIN,
  DEV_AUTH0_CLIENT_ID,
  DEV_AUTH0_AUDIENCE,
} from './constants';

export const getAuth0Tenant = () => {
  const isProd = isBaseUrlProd();

  return {
    domain: isProd ? AUTH0_DOMAIN : DEV_AUTH0_DOMAIN,
    clientId: isProd ? AUTH0_CLIENT_ID : DEV_AUTH0_CLIENT_ID,
    audience: isProd ? AUTH0_AUDIENCE : DEV_AUTH0_AUDIENCE,
  };
};
